import React from 'react';

class CreateAccountButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <button
                onClick={() => {
                    window.location.href = '/create';
                }}
            >
                Create Account
            </button>
        );
    }
}

export default CreateAccountButton;
